// Auto-generated translation for sv.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:11:50.772513+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "För hästägare",
    title: "Allt för din häst. I en app.",
    subtitle: "Hantera hälsa, träning, planering och fackmän från ett och samma överskådliga journalsystem.",
    primaryCTA: {
      label: "Kom igång gratis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Hästprofil — vikt, vaccination, EquiCoach, kost och träning i en vy",
      caption: "Din häst, helt i bild.",
    },
    problem: "Du håller förmodligen reda på bokningar, foton, träning, kost och hälsa utspritt — i WhatsApp-grupper, skokartonger och separata appar. Det gör att du tappar överblicken.",
    solution: "EquiSight förvandlar din häst till ett komplett digitalt journalsystem som följer med dig.",
    benefits: [
      "En komplett hästprofil per häst",
      "Hälsa, hovsmid, tandläkare och fysioterapeut på ett ställe",
      "Kalender med smarta påminnelser",
      "Foton, anteckningar och historik utan begränsning",
      "Säkerhetskopiering av all din data med Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 häst · alltid gratis",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Flera hästar + säkerhetskopiering",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Redo att börja?",
      title: "Kom igång med din första häst redan idag.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Fler hästar. Bättre överblick. Större trygghet.",
    subtitle: "Uppgradera till Premium och hantera alla dina hästar utan begränsningar — med full EquiCoach intelligence.",
    primaryCTA: {
      label: "Börja 14 dagar gratis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Alla priser",
      href: "/#pricing",
    },
    audience: "För ägare, tävlingsryttare och hästhållare med flera hästar.",
    features: [
      "Lägg till obegränsat antal hästar",
      "Fullständig historik per häst",
      "Datasäkerhetskopiering",
      "Utökade EquiCoach-insikter",
      "Smarta aviseringar och planering",
      "Hälsa och träning helt sammankopplade",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mindre än €0,17 per dag",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Redo?",
      title: "Uppgradera till Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "För ridhusryttare",
    title: "Bli bättre, även utan egen häst.",
    subtitle: "Följ dina lektioner, träningar och utveckling i EquiSight — för mindre än en kopp kaffe per månad för mamma eller pappa. Eller en god glass med grädde.",
    primaryCTA: {
      label: "Starta med Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Hur fungerar det?",
      href: "#features",
    },
    problem: "Som ridhusryttare har du ofta ingen egen häst, men du vill ändå utvecklas och ha överblick över dina lektioner, mål och de hästar du rider.",
    solution: "Ridhus­funktionalitet ingår som standard i Premium — följ din egen utveckling och visa kopplade ridhushästar i skrivskyddat läge.",
    features: [
      "Spåra träningar",
      "Sätta upp mål",
      "Följa framsteg",
      "Visa ridhushästar med namn och foto",
      "Ingen åtkomst till privat hälsodata",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per månad · ridhus­funktionalitet ingår",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bli medlem",
      title: "Kom igång som ridhusryttare.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "För ridskolor & stall",
    title: "Gör din ridskola digitalt tillgänglig för varje ryttare.",
    subtitle: "Ge ryttare anknytning till hästar, lektioner och framsteg — utan att dela känslig stalldata.",
    primaryCTA: {
      label: "Begär åtkomst",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Visa moduler",
      href: "#features",
    },
    audience: "EquiSight hjälper ridskolor och stall att hålla ryttare engagerade längre och sticka ut digitalt.",
    features: [
      "Göra ridskolehästar synliga för ryttare",
      "Namn och foto per häst",
      "Koppla ryttare till hästar",
      "Skrivskyddad åtkomst för integritetskänslig data",
      "Lektion- och träningshistorik samlat",
      "Användarhantering med roller",
    ],
    benefits: [
      "Starkare anknytning till ryttare",
      "Mer professionellt intryck",
      "Extra digital service för medlemmar",
      "Ny intäktsström via appanvändning",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per månad · ridskolefunktionalitet ingår för ryttare",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Redo?",
      title: "Aktivera Ridskolemodulen.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Avelmodul",
    title: "Full kontroll över cykel, dräktighet och fölutveckling.",
    subtitle: "Den kompletta avelmodulen för stohållare och uppfödare — från betäckning till föl, i en enda tidslinje.",
    primaryCTA: {
      label: "Aktivera Avelmodul",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Visa funktioner",
      href: "#features",
    },
    audience: "För uppfödare, stohållare och stall som hanterar flera ston.",
    features: [
      "Cykelspårning",
      "Registrera brunst",
      "Registrera inseminationsdatum",
      "Nedräkning till ultraljud",
      "Planera dräktighetskontroller",
      "Stamtavla och härstamning",
      "Fölutveckling",
      "Översikt över alla dräktiga ston",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Per månad · Avelmodul ingår i Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Kom igång idag",
      title: "Börja med avelhantering.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Hovsmeds-modul",
    title: "Arbeta smartare som hovsmed. Dokumentera allt på ett professionellt sätt.",
    subtitle: "Schema, foton, anteckningar och behandlingshistorik i en modul — mindre missförstånd, starkare journal.",
    primaryCTA: {
      label: "Kom igång som hovsmed",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Professional-paketet",
      href: "/professional",
    },
    audience: "För hovsmeder som vill förbättra överblicken, dokumentationen och kommunikationen med kunder.",
    features: [
      "Eget schema",
      "Bokningar per kund",
      "Visa hästprofiler",
      "Lägg till före- och efterbilder",
      "Notera behandling",
      "Registrera råd och kommentarer",
      "ETA-avisering till kund: \"Hovsmeden är på väg\"",
    ],
    benefits: [
      "Mer professionellt arbetssätt",
      "Färre missförstånd",
      "Bättre journaluppbyggnad",
      "Starkare vid ansvarsfrågor",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per månad · Hovsmeds-modulen ingår i Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Redo?",
      title: "Aktivera Hovsmeds-modulen.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Tandläkarmodul",
    title: "Ett komplett tandvårdsjournal per häst.",
    subtitle: "Registrera fynd, behandlingar och uppföljning direkt i EquiSight.",
    primaryCTA: {
      label: "Kom igång som hästtandläkare",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Professional-paketet",
      href: "/professional",
    },
    audience: "Hästtandläkare, veterinärer och kliniker som vill arbeta strukturerat.",
    features: [
      "Registrera tandkontroll",
      "Fynd per behandling",
      "Lägg till foton",
      "Rapportering till ägare",
      "Uppföljningsråd",
      "Historik per häst",
      "Planera nytt besök",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per månad · Tandläkarmodulen ingår i Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Redo?",
      title: "Aktivera tandläkarmodulen.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Fysio / Osteo-modul",
    title: "Följ kropp, rörelse och återhämtning på ett professionellt sätt.",
    subtitle: "För fysioterapeuter och osteopater som vill ge hästar strukturerad uppföljning.",
    primaryCTA: {
      label: "Kom igång som fysio/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Professional-paketet",
      href: "/professional",
    },
    features: [
      "Intag per häst",
      "Registrera kroppsfynd",
      "Lägg till foton och videor",
      "Skapa behandlingsrapport",
      "Dela övningar och uppföljning",
      "Följa återhämtningsförlopp",
      "Historik per häst",
    ],
    benefits: [
      "Bättre insikt över tid",
      "Professionell rapportering",
      "Tydlig kommunikation med ägare, tränare och ryttare",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per månad · Fysio / Osteo-modulen ingår i Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Redo?",
      title: "Aktivera Fysio / Osteo-modulen.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Tränarmodul",
    title: "Coacha ryttare med data, mål och framsteg.",
    subtitle: "Gör träningen mätbar och handledningen mer professionell — för en eller flera ryttare.",
    primaryCTA: {
      label: "Kom igång som tränare",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Pro-paketet",
      href: "/#pricing",
    },
    audience: "För instruktörer, tränare och coacher med flera ryttare eller hästar.",
    features: [
      "Koppla ryttare",
      "Följ hästar",
      "Sätt träningsmål",
      "Ge feedback",
      "Analysera tävlingsresultat",
      "Visa framsteg per kombination",
      "Använd protokollanalyser för träningsfokus",
    ],
    benefits: [
      "Bättre handledning",
      "Mer struktur",
      "Mer professionell kommunikation",
      "Starkare kundrelationer",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Per månad · Tränarmodul ingår i Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Redo?",
      title: "Aktivera tränarmodulen.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Tävlingsanalys",
    title: "Från protokoll till prestandaförbättring.",
    subtitle: "Ladda upp ditt tävlingsprotokoll och upptäck var du tappar poäng — inte bara se ditt resultat, utan förstå hur du blir bättre.",
    primaryCTA: {
      label: "Analysera ditt första protokoll",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Premium",
      href: "/premium",
    },
    features: [
      "Ladda upp protokollfoto",
      "Bearbeta fram- och baksida",
      "Känna igen klass, provnummer och domare",
      "Analysera poäng per moment",
      "Sammanfatta kommentarer",
      "Visa styrkor och svagheter",
      "Trender per häst-ryttarkombination",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per månad · tävlingsanalys ingår från och med Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Redo?",
      title: "Kom igång med tävlingsanalys.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional-paket",
    title: "För proffs inom hästvärlden.",
    subtitle: "Hovslагare, tandläkare, fysioterapeut, osteopat eller tränare: samarbeta i ett digitalt hästjournal.",
    primaryCTA: {
      label: "Kom igång som proffs",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se enskilda moduler",
      href: "#features",
    },
    audience: "Professional-paketet kombinerar alla fackmoduler i ett abonnemang.",
    features: [
      "Hovslagare-modul",
      "Tandläkare-modul",
      "Fysio / Osteopat-modul",
      "Kalender & kundhantering",
      "Hästprofiler & rapporter",
      "Behandlingshistorik & journaluppbyggnad",
      "Kommunikation med ägare",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per månad · alla fackmoduler ingår",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Redo?",
      title: "Välj Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Nödnummer häst",
    title: "Alltid rätt hjälp inom räckhåll.",
    subtitle: "I en nödsituation räknas varje sekund. Med EquiSight har du alla viktiga kontaktuppgifter för din häst direkt tillgängliga — ett tryck och du ringer.",
    primaryCTA: {
      label: "Förbered dina nödkontakter",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Kom igång gratis med EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Nödkontakter — ring direkt, WhatsAppa eller navigera till veterinär, klinik och hovslagare",
      caption: "Ett tryck. Ingen panik. Bara handling.",
      embeddedFrame: true,
    },
    problem: "Din häst mår illa — kolik, skada, panik. Och sedan börjar letandet. Vem ringer du? Har du rätt nummer? Är det akutnumret? Värdefull tid går förlorad.",
    solution: "Med EquiSight har du allt direkt till hands. Inget letande. Inget tvivel. Ett tryck och du har kontakt.",
    scenario: {
      title: "Tänk dig — din häst visar tecken på kolik.",
      steps: [
        "Du öppnar EquiSight",
        "Trycker på \"Veterinär\"",
        "Ringer direkt",
      ],
      tagline: "Ingen stress. Inget letande. Bara handling.",
    },
    features: [
      "Alla nödnummer på ett ställe",
      "Ring med ett tryck direkt från appen",
      "WhatsAppa med ett tryck",
      "Navigera direkt till adressen",
      "Egen kontaktlista per häst",
      "Veterinär, klinik, hovslagare, tandläkare, fysioterapeut",
      "Adress och vägbeskrivning direkt tillgänglig",
      "Markera favoritnummer med en stjärna",
      "Akutnummer (112, 144) alltid högst upp",
    ],
    benefits: [
      "Lugn och kontroll i en nödsituation",
      "Alla på stallet har samma nummer tillgängliga",
      "Inga bortglömda visitkort mer",
      "Reagera sekunder snabbare vid akuta situationer",
    ],
    audience: "För hästägare, skötare, tränare och stall — alla som är ansvariga för en häst.",
    showcase: {
      eyebrow: "Förinställt åt dig",
      title: "13 kategorier av kontakter — redo att fylla i.",
      description: "Från veterinär och akutklinik till sadelmakare, instruktör och betesansvarig. EquiSight känner din värld och förbereder rätt kontaktfält åt dig. Tryck, fyll i, klart.",
      bullets: [
        "Akut & hälsa — veterinär, akut, klinik, giftinformationslinje",
        "Daglig skötsel — hovslagare, tandläkare, fysioterapeut, instruktör",
        "Stall & bete — stallägare, betesansvarig, inackorderingsstall",
        "Foder & material — hö, kraftfoder, halmleverantörer",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Hanteringsskärm för nödkontakter — alla föreslagna kontakter per kategori",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Checklista nödnummer häst",
      items: [
        "Veterinär",
        "Akutklinik (24/7)",
        "Djurambulans · 144",
        "Hovslagare",
        "Reservkontaktperson",
        "Allmänt larmnummer · 112",
      ],
      cta: {
        label: "Öppna i EquiSight och fyll i direkt",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Nödnummer",
          price: "Gratis",
          note: "Alltid gratis · för alla, i varje prenumeration",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Se till att du är förberedd",
      title: "Innan det behövs.",
      href: "/#waitlist",
    },
    microcopy: [
      "Inga förpliktelser",
      "Inställt på 2 minuter",
      "Alltid anpassningsbart",
    ],
  },
};

export default LANDINGS;
